<template>
  <div class="mx-auto container py-24">
    <div class="w-full lg:flex gap-8 justify-between items-center">
      <div class="w-full">
        <img
          src="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/Cg-img/Donation%20page%20-%20ESG%20CSR%20Partnerships.jpg"
          alt="bg-polygon"
          class="h-full"
        />
      </div>
      <div class="w-full">
        <h1 class="text-black text-3xl font-bold">ESG/ CSR Partnerships:</h1>
        <p class="subtitle fsize18 lh32px sm-fsize14 mt-3 ellipsis-4">
          The latest guidelines on Environmental, Social and Governance (ESG)
          encourage organizations to think about the role they are playing in
          society through Individual Social responsibility and the people who
          are associated as employees, clients or vendors.
          <span v-if="readESG"></span><span v-else>...</span>
          <br />
          <br />
        </p>
        <div class="subtitle fsize18 lh32px sm-fsize14" v-show="readESG">
          <p>
            We look forward to partnering with you in your Environmental, Social
            and Governance (ESG)/ Corporate Social Responsibility (CSR) programs
            that may be directed at Gender Equality, Livelihoods and financial
            independence for Women, Universal healthcare especially access to
            mental health for all and Inclusive Growth (DEI).
            <br />
            <br />
            An opportunity for business organisations to participate in building
            a sustainable community for caregivers and contribute in impacting
            the care economy in many ways.
          </p>
        </div>
        <p class="cursor-pointer" @click="readESG = !readESG">
          <span class="fsize15 sm-fsize14 text-063a88 underline" v-if="readESG"
            >Read less</span
          >
          <span class="fsize15 sm-fsize14 text-063a88 underline" v-else
            >Read more</span
          >
        </p>
        <h1 class="text-black text-lg font-semibold mt-5">Our Programs</h1>
        <div
          class="mt-4 md:py-4 lg:py-4 py-4 md:px-4 lg:px-4 px-4 cust-shadow-FAQ rounded-lg bg-white z-10"
          v-for="(item, index) in faq"
          :key="index"
        >
          <div
            class="flex items-center w-full justify-between"
            block
            v-b-toggle="'accordion-' + index"
          >
            <p class="subtitle txt-FAQ-A fsize16 sm-fsize14">
              {{ item.que }}
            </p>
            <!-- <img
              src="@/assets/images/caregiver/downIcon.svg"
              alt="Downicon"
              class="md:h-4 lg:h-4 h-2 w-6"
            /> -->
          </div>

          <!-- <p class="subtitle pt-3 fsize20-14px">
            {{ item.answer }}
          </p> -->
        </div>
        <!-- <a
          href="https://nimbus-server-01.brained.in/nimbus-server-01/caregiversaathi/all-in-one/Impact%20Report%202021v%201.0.pdf"
          target="blank"
        > -->
        <a
          href="https://nimbus-server-01.brained.in/nimbus-server-01/image/Caregiver%20Saathi%20Impact%20_Annual%20Report%202023.pdf"
          target="blank"
        >
          <b-button variant="primary" class="mt-8 px-12 py-3 fsize16">
            Our Impact Report</b-button
          ></a
        >
      </div>
    </div>
    <div class="flex justify-center w-full lg:mt-9 mt-6">
      <div>
        <p class="text-center fsize14 smfsize10">
          If you have any questions or would like to share any feedback with us
          mail at
        </p>
        <p class="text-center text-primary font-semibold underline">
          <a href="mailto:donations@caregiversaathi.co.in"
            >donations@caregiversaathi.co.in</a
          >
        </p>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      readESG: false,
      faq: [
        {
          id: "01",
          que: "Livelihoods and Training of women as Care Workers in Palliative Care and for specific medical conditions like Dementia, ALS ",
          answer:
            "The insights section on our website has a list of resources where you can get information, tips and tools for guidance through your caregiving journey. You need to register and create your login profile to access the same. ",
        },
        {
          id: "02",
          que: "Research, Advocacy and Awareness of palliative care among communities through outreach programs for the marginalized ",
          answer:
            "Yes. We partner with verified and trusted caregiving agencies and we will help you through the hiring process based on your requirements. Please fill in the inquiry form and we will get back to you. ",
        },
        {
          id: "03",
          que: "Volunteering opportunities for employees at Caregiver Saathi- which range from supporting community visits for home-based care, conducting workshops and providing organizational administrative support",
          answer:
            "We understand that the role of caregiving can be overwhelming and stressful. Join our community of caregivers and get to meet, share and learn from active and erstwhile caregivers and healthcare professionals too. ",
        },
      ],
    };
  },
  methods: {
    handleClick(name) {
      this.$router.push({ name: name });
    },
  },
};
</script>
